import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'semantic-ui-react';
import DatePicker from '../../../DatePicker';
import moment from 'moment';
import styles from './SelectEffectiveDate.module.scss';

const SelectEffectiveDate = ({ onCancel, onSelect, message, showFraudWarning, min, max }) => {
	const minDate = useMemo(() => Date.parse(moment(min).format()), [min]);
	const maxDate = useMemo(() => Date.parse(moment(max)), [max]);

	const [effectiveDate, setEffectiveDate] = useState(null);
	const [open, setOpen] = useState(false);

	return (
		<div>
			<div>{message}</div>
			<Form>
				<Form.Field required inline>
					<label>Effective Date</label>
					<DatePicker id='effectiveDate' name='date' selected={effectiveDate} onChange={(_, { value }) => setEffectiveDate(value)} dateFormat='MM/dd/yyyy' minDate={minDate} maxDate={maxDate} />
				</Form.Field>
			</Form>
			<div className={styles.buttons}>
				{showFraudWarning && (
					<Modal
						open={open}
						onOpen={() => setOpen(true)}
						size='small'
						trigger={
							<Button id='continueBtn' primary disabled={!effectiveDate}>
								Continue
							</Button>
						}>
						<Modal.Header>WARNING!!!</Modal.Header>
						<Modal.Content>
							<p>ANY PERSON WHO KNOWINGLY AND WITH INTENT TO DEFRAUD ANY INSURANCE COMPANY OR ANOTHER PERSON FILES AN APPLICATION FOR INSURANCE OR STATEMENT OF CLAIM CONTAINING ANY MATERIALLY FALSE OR DECEPTIVE INFORMATION, OR CONCEALS FOR THE PURPOSE OF MISLEADING INFORMATION CONCERNING ANY FACT MATERIAL THERETO, COMMITS A FRAUDULENT INSURANCE ACT, WHICH IS A CRIME AND SUBJECTS THE PERSON TO CRIMINAL AND CIVIL PENALTIES.</p>
							<p>YOU AGREE THAT YOU HAVE READ AND REVIEWED ALL INFORMATION YOU HAVE PROVIDED AND YOU DECLARE THAT THE INFORMATION PROVIDED IS TRUE, COMPLETE AND CORRECT TO THE BEST OF YOUR KNOWLEDGE AND BELIEF.</p>
						</Modal.Content>
						<Modal.Actions>
							<Button id='modalContinueBtn' primary onClick={() => onSelect(moment(effectiveDate))}>
								Continue
							</Button>
							<Button id='modalCancelBtn' primary onClick={() => setOpen(false)}>
								Cancel
							</Button>
						</Modal.Actions>
					</Modal>
				)}

				{!showFraudWarning && (
					<Button id='continueBtn' primary disabled={!effectiveDate} onClick={() => onSelect(moment(effectiveDate))}>
						Continue
					</Button>
				)}

				<Button id='cancelBtn' primary onClick={onCancel}>
					Cancel
				</Button>
			</div>
		</div>
	);
};

SelectEffectiveDate.propTypes = {
	onSelect: PropTypes.func.isRequired,
};

export default SelectEffectiveDate;
